import type { PresignUrlRequest, PresignUrlRequestPayload } from "../ts";

export const serializePresignUrlPyalod = async (
  data: PresignUrlRequest,
): Promise<PresignUrlRequestPayload> => {
  const formData = {
    file_name: data.file_name,
    file_type: data.file_type,
  };
  return formData;
};
